import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import UploadImage from "@/components/Upload/upload-image.vue";
import { configApp, initialLanguageEdit, initialLanguageCurrent } from "@/service/appList";
import { mapState } from "vuex";
export default {
  name: "BaseInfoForm",
  props: {
    appdetail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    UploadImage
  },
  computed: {
    _language() {
      return this.formData.appId === "ID_OPERA_CLOUD";
    },
    appinfo() {
      return this.$route.query;
    },
    ...mapState({
      appCode: state => state.app.appCode,
      user: state => state.user,
      tabList: state => state.tabs.options
    })
  },
  data() {
    return {
      formData: {
        name: "",
        icon: "",
        isHalt: "F",
        level: "",
        securityLevel: 3.4,
        downloadUrl: "",
        introduction: "",
        language: "en-US",
        // appName是否被更改
        isChangeName: false
      },
      formRules: {
        downloadUrl: [{
          required: true,
          message: $t("n3a0tx7", "请输入下载地址"),
          trigger: "blur"
        }],
        introduction: [{
          required: true,
          message: $t("l437hd7", "请输入应用介绍"),
          trigger: "blur"
        }]
      },
      languageList: [{
        title: $t("yd413r5", "中文(简)"),
        value: "zh-CN"
      }, {
        title: $t("yd4hyu5", "中文(繁)"),
        value: "zh-TW"
      }, {
        title: "English",
        value: "en-US"
      }, {
        title: $t("82m34e9", "跟随iWork系统"),
        value: "@CURRENT@"
      }],
      languageValue: ""
    };
  },
  methods: {
    async handleSubmit() {
      let params = JSON.parse(JSON.stringify({
        ...this.appinfo,
        ...this.formData
      }));
      let {
        unitId
      } = this.user.userInfo;
      let {
        data: {
          result
        }
      } = await configApp({
        ...params,
        unitId
      });
      if (result === 0) {
        this.$Message.success($t("ai8d7e4", "修改成功"));
      }
    },
    async changeName(event) {
      this.formData.name = event.target.value;
      this.isChangeName = true;
    },
    async getInitLanguage() {
      const params = {
        appCode: this.formData.appCode
      };
      let {
        data
      } = await initialLanguageCurrent(params);
      if (data && data.result == 0) {
        this.languageValue = data.retVal || "en-US";
      }
    },
    /*
     * 切换语言
     */
    async onChangeLanguage(language) {
      let {
        data
      } = await initialLanguageEdit({
        appCode: this.formData.appCode,
        language: language
      });
      if (data && data.result == 0) {
        this.$Message.success($t("ai8d7e4", "修改成功"));
        this.languageValue = language;
      }
    }
  },
  watch: {
    appdetail: function (val) {
      this.formData = val;
      if (this._language) {
        this.getInitLanguage();
      }
    }
  }
};